module.exports = __webpack_public_path__ + "assets/steps.8eee06d4.svg";